export const iconFontAwesomeGendersGenderless = (
	<i className="fa-solid fa-genderless"></i>
);
